// TabsComponent.js
import React from "react";
import { Grid2 } from "@mui/material";
import styles from "./TabsComponent.module.scss";

const TabsComponent = ({ tabs, selectedTab, setSelectedTab }) => {
  return (
    <Grid2 className={styles.Container}>
      {tabs?.map((tab, index) => (
        <Grid2
          key={index}
          className={
            selectedTab.value === tab.value
              ? `${styles.ActiveContainerItem} ActiveNavItem`
              : `${styles.InActiveContainerItem} InActiveNavItem`
          }
          onClick={() => setSelectedTab(tab)}
        >
          {tab.title}
        </Grid2>
      ))}
    </Grid2>
  );
};

export default TabsComponent;
